import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/ivar/behaviors/addProduct';
import { matchInteriorsToSections } from 'rangeConfig/ivar/filters/mainMenuProductFilter';

const interiorsProductListConfig: ProductListConfig = {
  cardsSubtitle: 'typeName, designText',
  infoButtonAriaLabel: 'storageone.productListInteriorsTitle',
  sortOrder: [],
  categories: [
    {
      id: 'interiors',
      products: [
        { path: 'type', value: ProductType.IVAR_SHELF_PINE },
        { path: 'type', value: ProductType.IVAR_SHELF_FELT },
        { path: 'type', value: ProductType.IVAR_SHELF_METAL },
        { path: 'type', value: ProductType.IVAR_BOTTLE_RACK },
        { path: 'type', value: ProductType.IVAR_DRAWER_PINE },
        { path: 'type', value: ProductType.IVAR_CORNER_SHELF }
      ]
    },
    {
      id: 'interiors',
      products: [
        { path: 'type', value: ProductType.IVAR_CLOTHES_RAIL },
        { path: 'type', value: ProductType.IVAR_TABLE },
        { path: 'type', value: ProductType.IVAR_STORAGE_BOX },
        { path: 'type', value: ProductType.IVAR_DRAWER_METAL }
      ],
      cluster: ['type', 'communicatedSizeText', 'appearances.0.color']
    }
  ],
  productFilters: [matchInteriorsToSections],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  cluster: ['type']
};

export default interiorsProductListConfig;
